import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Header({ title, onBack, icon: Icon }) {
  const navigate = useNavigate();

  // Explicit onBack (e.g. "items always go back to their category") always wins.
  // Falls back to plain browser-history back only if no explicit path makes sense for this page.
  const handleBack = onBack || (() => navigate(-1));
  const showBack = onBack !== null; // pass onBack={null} explicitly if a page should have no back arrow at all

  return (
    <div className="bg-indigo-900 text-white p-4 sm:p-6 shadow-lg">
      <div className="flex items-center space-x-3">
        {showBack && (
          <button
            onClick={handleBack}
            className="p-2 hover:bg-indigo-800 rounded-lg transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft className="h-5 w-5 sm:h-6 sm:w-6" />
          </button>
        )}
        {Icon && <Icon className="h-6 w-6 sm:h-8 sm:w-8" />}
        <h1 className="text-xl sm:text-2xl font-bold">{title}</h1>
      </div>
    </div>
  );
}